export function PremiumUpsellCard() {
    return (
        <div className="flex justify-center px-4 py-8">
            <div className="bg-background border-[0.5px] border-[var(--color-border-tertiary)] rounded-lg p-8 max-w-[340px] w-full text-center">

                <div className="flex justify-center mb-4">
                    <img src="/img/pwa-icon/i-icon-bg-transparent.svg" className="size-16"/>
                </div>

                <p className="text-lg font-medium text-primary mb-2">
                    Du har tagit det första steget
                </p>

                <p className="text-sm mb-6 leading-relaxed">
                    Resten av resan väntar på dig.
                    <br />
                    Premium ger dig tillgång till hela filosofin – steg för steg, i din egen takt.
                </p>

                <div className="border-t-[0.5px] border-[var(--color-border-tertiary)] pt-5">
                    <a
                        href="mailto:hello@daretolive.se?subject=Jag vill veta mer om Hopeifier Premium"
                        className="block w-full py-3 px-4 bg-[#1B3A6B] text-white rounded-md text-[15px] font-medium no-underline"
                    >
                        Kontakta oss för att komma igång
                    </a>
                </div>

            </div>
        </div>
    );
}